import { getCookieConsentValue } from "react-cookie-consent";
import ReactGA from "react-ga4";

/**
 * Track page views in our app
 * make sure we check cookie consent value before doing so
 */
export function trackPageView(page: string) {
  if (getCookieConsentValue() !== "true") return;

  if (ReactGA.isInitialized) ReactGA.pageview(page);
}
